import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[mapSearchResult]' })
export class MapSearchResultDirective {
  public constructor(public viewContainerRef: ViewContainerRef) {}
}
